import { useSelector } from 'react-redux';
import { IRootReducerState } from 'store/store';

export const useIsTouched = (questionName: string) => {
  const { touchedQuestionNames, areAllFieldsTouched } = useSelector(
    (state: IRootReducerState) => state.formInfo
  );
  return areAllFieldsTouched || touchedQuestionNames.includes(questionName);
};
